import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal, Button } from 'antd';
import { hideAlert } from '../../../../common/redux/actions/alert';

class GlobalAlert extends React.Component {
  state = {
    alertIsOpened: false,
  };
  static getDerivedStateFromProps(props, state) {
    const { alert } = props;
    if (props) {
      state = { alertIsOpened: alert.alertIsOpened };
    }
    return state;
  }
  render() {
    const { alertIsOpened } = this.state;
    const { alert } = this.props;
    return (
      <div>
        <Modal
          visible={alertIsOpened}
          title="Произошла ошибка!"
          footer={[
            <Button
              key="back"
              onClick={() => {
                this.props.hideAlert();
                this.props.history.goBack();
              }}
            >
              Назад
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => this.props.hideAlert()}
            >
              Ok
            </Button>,
          ]}
        >
          {alert.errorMessage}
        </Modal>
      </div>
    );
  }
}

export default connect(
  state => ({
    alert: state.Common.Alert.alert,
  }),
  {
    hideAlert,
  }
)(withRouter(GlobalAlert));
